import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Ejendomsservice from './pages/Ejendomsservice';
import OtherTasks from './pages/OtherTasks';
import ServiceDetail from './pages/ServiceDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen font-sans text-emerald-950 selection:bg-emerald-200 selection:text-emerald-900">
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ejendomsservice" element={<Ejendomsservice />} />
            <Route path="/andre-opgaver" element={<OtherTasks />} />
            <Route path="/andre-opgaver/:slug" element={<ServiceDetail />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
